import { render } from "./UnCollected.vue?vue&type=template&id=701cf525"
import script from "./UnCollected.vue?vue&type=script&lang=js"
export * from "./UnCollected.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__